(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('troubleshooting', ["feature", "sideMenuManager", function (feature, sideMenuManager) {
        var troubleshooting = {
            available: function () {
                return feature.troubleshooting;
            },
            enabled: function (newState) {
                if (!troubleshooting.entityDebugEnabled()) {
                    return false;
                }
                if (_(newState).isBoolean()) {
                    localStorage.setItem('troubleshootingEnabled', JSON.stringify(newState));
                    return newState;
                }
                var stored = localStorage.getItem('troubleshootingEnabled');
                if (stored) {
                    return JSON.parse(stored);
                }
                return false;
            },
            entityDebugEnabled: function (newState) {
                var currentUser = sideMenuManager.currentUser();
                if (!currentUser || !currentUser.email) {
                    return false;
                }
                if (!feature.allowDebugAllEmails && !/@avanan\.com$/i.test(currentUser.email) && !currentUser.hidden && (!feature.allowDebugEmails || !_(feature.allowDebugEmails).includes(currentUser.email))) {
                    return false;
                }
                if (_(newState).isBoolean()) {
                    localStorage.setItem('entityDebugEnabled', JSON.stringify(newState));
                    return newState;
                }
                var stored = localStorage.getItem('entityDebugEnabled');
                if (stored) {
                    return JSON.parse(stored);
                }
                return false;
            }
        };
        return troubleshooting;
    }]);
}());